module.exports = __webpack_public_path__ + "static/media/d.7c6b02fa.m4a";